import { render, staticRenderFns } from "./email-address.vue?vue&type=template&id=d5e42d14&scoped=true&"
var script = {}
import style0 from "./email-address.vue?vue&type=style&index=0&id=d5e42d14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e42d14",
  null
  
)

export default component.exports